import { FormattedAdvancedWorkflowDetailsConfiguration } from "@idw-types/data/workflow-details-configuration";

export enum WorkflowDetailsActionTypes {
    SET_ADVANCED_WORKFLOW_DETAILS_LOADING = "SET_ADVANCED_WORKFLOW_DETAILS_LOADING",
    SET_ADVANCED_WORKFLOW_DETAILS = "SET_ADVANCED_WORKFLOW_DETAILS"
}

// Data
type SetAdvancedWorkflowDetailsLoadingAction = {
    type: WorkflowDetailsActionTypes.SET_ADVANCED_WORKFLOW_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setAdvancedWorkflowDetailsLoading = (isLoading: boolean): SetAdvancedWorkflowDetailsLoadingAction => ({
    type: WorkflowDetailsActionTypes.SET_ADVANCED_WORKFLOW_DETAILS_LOADING,
    payload: { isLoading }
});

type SetAdvancedWorkflowDetailsAction = {
    type: WorkflowDetailsActionTypes.SET_ADVANCED_WORKFLOW_DETAILS,
    payload: {
        advancedWorkflowDetails: FormattedAdvancedWorkflowDetailsConfiguration;
        shouldRefreshComponentState: boolean;
    }
};

export const setAdvancedWorkflowDetails = (
    advancedWorkflowDetails: FormattedAdvancedWorkflowDetailsConfiguration,
    shouldRefreshComponentState: boolean
): SetAdvancedWorkflowDetailsAction => ({
    type: WorkflowDetailsActionTypes.SET_ADVANCED_WORKFLOW_DETAILS,
    payload: {
        advancedWorkflowDetails,
        shouldRefreshComponentState
    }
});

export type WorkflowDetailsActions =
    SetAdvancedWorkflowDetailsLoadingAction |
    SetAdvancedWorkflowDetailsAction
